import { useEffect, useRef } from 'react';
import './Titlebar.css';
import { getCurrentWindow } from '@tauri-apps/api/window';
import { CropSquare, Close, Remove } from '@mui/icons-material';

function Titlebar() {
    const minimizeRef = useRef(null);
    const maximizeRef = useRef(null);
    const closeRef = useRef(null);
    const appWindow = getCurrentWindow();

    useEffect(() => {
        const minimizeHandler = () => appWindow.minimize();
        const maximizeHandler = () => appWindow.toggleMaximize();
        const closeHandler = () => appWindow.close();

        const minimizeButton = minimizeRef.current;
        const maximizeButton = maximizeRef.current;
        const closeButton = closeRef.current;

        if (minimizeButton) minimizeButton.addEventListener('click', minimizeHandler);
        if (maximizeButton) maximizeButton.addEventListener('click', maximizeHandler);
        if (closeButton) closeButton.addEventListener('click', closeHandler);

        return () => {
            if (minimizeButton) minimizeButton.removeEventListener('click', minimizeHandler);
            if (maximizeButton) maximizeButton.removeEventListener('click', maximizeHandler);
            if (closeButton) closeButton.removeEventListener('click', closeHandler);
        };
    }, []);

    return (
        <div data-tauri-drag-region className="titlebar">
            <div className="titlebar-title">
                <img style={{ height: '12px', marginRight: '8px' }} src='./favicon.ico' />
                Capricorn
            </div>
            <div>
                <div className="titlebar-button" ref={minimizeRef}>
                    <Remove sx={{ height: 16 }} />
                </div>
                <div className="titlebar-button" ref={maximizeRef}>
                    <CropSquare sx={{ height: 16 }} />
                </div>
                <div className="titlebar-button" ref={closeRef}>
                    <Close sx={{ height: 16 }} />
                </div>
            </div>
        </div>
    );
}

export default Titlebar;
